<div [formGroup]="formGroup">
  <input type="datetime-local" [formControlName]="field.name" [id]="field.name" />
</div>
